export interface ThemeConfig {
  id: number;
  name: string;
  description: string;
  gradient: string;
  vfxCompatible: 'excellent' | 'good' | 'fair';
  bestFor: string;
}

export const APP_THEMES: ThemeConfig[] = [
  {
    id: 1,
    name: 'Kiosk Blue',
    description: 'Radial blue gradient from #03C to #001233 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#0033CC_0%,_#001233_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Default theme - works with all VFX'
  },
  {
    id: 2,
    name: 'Royal Orange',
    description: 'Radial gradient from #ED671F to #270202 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#ED671F_0%,_#270202_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Gold/white particle effects'
  },
  {
    id: 3,
    name: 'Golden Olive',
    description: 'Radial gradient from #564606 to #181301 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#564606_0%,_#181301_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Light colored VFX (gold, white, cyan)'
  },
  {
    id: 4,
    name: 'Deep Purple',
    description: 'Radial gradient from #7400CC to #280443 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#7400CC_0%,_#280443_100%)]',
    vfxCompatible: 'good',
    bestFor: 'Gold, white, or pink VFX'
  },
  {
    id: 5,
    name: 'Slate Gray',
    description: 'Radial gradient from #8F93A0 to #151515 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#8F93A0_0%,_#37383C_71.78%,_#151515_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Gold, white, or cyan VFX'
  },
  {
    id: 6,
    name: 'Magenta Night',
    description: 'Radial gradient from #B100CC to #3A0143 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#B100CC_0%,_#3A0143_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Any colored VFX - darkest theme'
  },
  {
    id: 7,
    name: 'Teal Green',
    description: 'Radial gradient from #00CC96 to #003729 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#00CC96_0%,_#003729_100%)]',
    vfxCompatible: 'good',
    bestFor: 'White, gold, or cyan VFX'
  },
  {
    id: 8,
    name: 'Cyan Depth',
    description: 'Radial gradient from #0DDAF1 to #012D32 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#0DDAF1_0%,_#012D32_100%)]',
    vfxCompatible: 'good',
    bestFor: 'White or cyan VFX'
  },
  {
    id: 9,
    name: 'Golden Yellow',
    description: 'Radial gradient from #FFED4A to #3D3702 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#FFED4A_0%,_#3D3702_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'White, gold, or cyan VFX'
  },
  {
    id: 10,
    name: 'Violet Storm',
    description: 'Radial gradient from #9317E6 to #370558 (Figma design)',
    gradient: 'bg-[radial-gradient(94.34%_58.96%_at_50%_50%,_#9317E6_0%,_#370558_100%)]',
    vfxCompatible: 'excellent',
    bestFor: 'Any colored VFX - neutral tone'
  }
];

